import { useParams } from "@solidjs/router"
import { getTitle } from "@/lib/getTitle"
import { createMatrixParams } from "@/lib/matrixParams"
import { generateUrl } from "@/lib/slug"

const STORIES_BASE_PATH = "/bookmarks" as const

export const FILTER = {
  all: { value: "all", iconName: "filter", hue: "sand" },
  offline: { value: "offline", iconName: "download-cloud", hue: "emerald" },
} as const
export type Filter = keyof typeof FILTER

interface ListParams {
  filter: Filter
  query: string
  tag: string
  page: number
}
const LIST_DEFAULTS: ListParams = {
  filter: "all",
  tag: "all",
  query: "",
  page: 1,
}

export function createStoriesRouter() {
  const params = useParams()

  const list = createMatrixParams(() => params.listParams, LIST_DEFAULTS)

  function paths(listParams?: Partial<ListParams>) {
    const url = `${STORIES_BASE_PATH}${list.makeURL(listParams)}`

    return {
      url,
      share: () => `${url}/share`,
      add: () => `${url}/add`,
      story: (story?: { id: string; dc_title: string | null }) => {
        const id = story
          ? generateUrl(getTitle(story.dc_title), story.id)
          : params.storyId
        const storyUrl = [url, "story", id].filter(Boolean).join("/")

        return { url: storyUrl, commentary: () => `${storyUrl}/commentary` }
      },
    }
  }

  return {
    paths,
    listParams: list.matrixParams,
  }
}
